import translations from '../../translations';

interface Props {
    error: string | null;
    retry: () => void;
    environmentsEnabled: boolean;
    isMCR: boolean;
}

const ActivateFailed = ({ error, retry, environmentsEnabled, isMCR }: Props) => {
    return (
        <>
            {isMCR ? (
                <h3>{translations.FLOW_mcr_acknowledgement_failed}</h3>
            ) : (
                <h3>
                    {environmentsEnabled
                        ? translations.FLOW_build_failed
                        : translations.FLOW_publish_failed}
                </h3>
            )}
            <p>{error}</p>
            <button className="btn btn-primary" onClick={retry} type="button">
                {translations.FLOW_retry_button}
            </button>
        </>
    );
};

export default ActivateFailed;
